import { Component, OnInit } from '@angular/core';
import { AbstractDataProvider } from '../AbstractDataProvider';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthServiceCustom } from 'src/shared/service/auth.service';
import { DataItemModel, Fund, ResponseModel } from '../../shared/model/interfaces';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SortDescriptor } from '@progress/kendo-data-query';
import { GenericFilterModel } from '../security/QueryStringParam';
import { DictionaryPipe } from '../../shared/pipes/dictionary.pipe';
import {getErrorMessageText} from '../helper';

@Component({
    selector: 'app-forms',
    templateUrl: './forms.component.html',
    styleUrls: ['./forms.component.scss'],
    providers: [DictionaryPipe],
    standalone: false
})
export class FormsComponent implements OnInit {
  public forms: DataItemModel[] = [];
  downloadDocumentImagUrl: string = this.abstractDataProvider.baseUrl + 'api/File/FileDownloadFromDocumentImage?SeqNum=';
  display = false;
  alertMessage: string;
  public introText: string;

  public loading: boolean;
  public funds: Fund[] = [];
  public fund = '0';
  public sort: SortDescriptor[] = [{
    field: 'Label',
    dir: 'asc'
  }];

  constructor(
    private abstractDataProvider: AbstractDataProvider,
    private authService: AuthServiceCustom,
    private ngxService: NgxUiLoaderService,
    private dictionaryPipe: DictionaryPipe) {
  }

  ngOnInit() {
    this.getData();
    this.getIntroText();
  }


  getData(): void {
    this.loading = true;
    const req1 = this.abstractDataProvider.getData('api/Fund/GetFunds');
    const req2 = this.abstractDataProvider.postData(this.getDto(), 'api/Form/GetForm');
    forkJoin([req1, req2]).pipe(finalize(() => this.loading = false))
      .subscribe((data: any[]) => {
          this.forms = data[1].Data;
          this.funds = data[0].Funds;
        },
        error => {
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        });
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.search();
  }

  getIntroText() {
    this.introText = this.authService.getIntroText('FORMS');
  }

  search(): void {
    this.forms = [];
    this.loading = true;
    this.abstractDataProvider.postData(this.getDto(), 'api/Form/GetForm')
      .pipe(finalize(() => this.loading = false))
      .subscribe((forms: ResponseModel<DataItemModel>) => {
        this.forms = forms.Data;
      }, error => {
        this.display = true;
        this.alertMessage =  getErrorMessageText(error);
      });

  }

  getDto(): GenericFilterModel {
    return {
      Filters: [
        {Key: 'fund', Value: this.fund}
      ],
      SortField: this.sort[0].field,
      SortOrder: this.sort[0].dir,
    };
  }

  openDocument(SeqNum: any, FileNum: any) {
    this.abstractDataProvider.getData('api/File/IsFileExist?SeqNum=' + SeqNum + '&forWhat=form')
      .subscribe(
        posts => {
          this.ngxService.stop();
          if (posts.Message) {
            this.display = true;
            this.alertMessage = posts.Message;
          } else if (posts.DocSeqNum) {
            // window.open(this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum, '_blank');
            const fileUrl = this.downloadDocumentImagUrl + posts.DocSeqNum + '&forWhat=form&CurrentUserNumber=' + posts.CurrentUserNumber + '&FileNum=' + FileNum
            this.abstractDataProvider.downloadFile(fileUrl)
              .subscribe(_ => {}, error => {
                this.ngxService.stop();
                this.display = true;
                this.alertMessage =  getErrorMessageText(error);
              });
          } else {
            // Not Found
            this.display = true;
            this.alertMessage = this.dictionaryPipe.transform('FILE_NOT_FOUND');
          }
        },
        error => {
          this.ngxService.stop();
          this.display = true;
          this.alertMessage =  getErrorMessageText(error);
        }
      );
  }

  onConfirm() {
    this.display = false;
  }
}
